<script lang="ts" setup>
import HoverPinIcon from '@/components/icons/HoverPinIcon.vue';
import PinIcon from '@/components/icons/PinIcon.vue';
import UnpinnedIcon from '@/components/icons/UnpinnedIcon.vue';

defineProps<{ pinned: boolean }>();
</script>

<template>
  <div :class="{ pinned: pinned, unpinned: !pinned }">
    <UnpinnedIcon class="unpinned-icon" v-if="!pinned" />
    <HoverPinIcon class="hover-pin-icon" />
    <PinIcon class="active-pin-icon" v-if="pinned" />
  </div>
</template>

<style scoped lang="scss">
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/layout/grid-vars';

.pinned,
.unpinned {
  margin-right: grid-vars.space(1);

  :deep(svg) {
    min-height: 45px;
    min-width: 45px;
  }
}
.pinned .hover-pin-icon {
  display: none;
}
.unpinned .hover-pin-icon {
  display: none;
}
.unpinned:hover .hover-pin-icon {
  display: inline;
}
.unpinned:hover .unpinned-icon {
  display: none;
}
</style>
